<template>
  <a-modal
      title="专家列表"
      :visible="visible"
      @ok="handleOk"
      :maskClosable="false"
      @cancel="handleCancel"
      :confirm-loading="confirmLoading"
      :width="1300"
  >
    <div>
      <a-form-model :model="queryParam" layout="inline">
        <a-form-model-item label="身份证">
          <a-input placeholder="身份证" v-model="queryParam.idCard" style="width:250px"></a-input>
        </a-form-model-item>
        <a-form-model-item label="专家名称">
          <a-input placeholder="专家名称(多个专家用,隔开)" v-model="queryParam.expertName"
                   style="width:250px"></a-input>
        </a-form-model-item>
        <a-form-model-item label="品目编码|名称">
          <a-input placeholder="请输入需要查询的品目编码" v-model="queryParam.purchaseItem"
                   style="width:250px"></a-input>
        </a-form-model-item>
        <a-form-model-item label="手机号">
          <a-input placeholder="手机号" v-model="queryParam.mobilePhone" style="width:250px"></a-input>
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" class="ml-5" icon="search" @click="onSearch">查询</a-button>
          <a-button type="Default" class="ml-5" @click="clearMethod">清空</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div class="mt-4">
      已选择专家：
      <a-button-group size="small" class="ml-2 mt-2" v-for="(item) in userSelectContent">
        <a-button>{{ item.expertName }}</a-button>
        <a-button @click="removeMethod(item)" type="danger">
          <a-icon type="delete"></a-icon>
        </a-button>
      </a-button-group>
    </div>
    <s-table
        class="mt-4"
        ref="table"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :columns="columns"
        :pagination="taskPagination"
        :pageSize="pageSize"
        :data="loadData"
        :rowKey="record => record.id"
    >
      <template v-slot:expertName="record">
        {{ record.expertName }}<br>{{ record.idCard }}
      </template>
    </s-table>
  </a-modal>
</template>

<script>
import { PageView } from '@/layouts'
import STable from '@/components/Table'
import { QueryExpertInfo } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import { ExpertState } from '@/epp/expertmain/expertInfo/utils/ExpertInfoUtil'

export default {
  name: 'SelectExpertModal',
  components: {
    PageView,
    STable
  },
  mounted () {
  },
  watch: {
    visible (val) {
      if (val) {
        if (this.$refs.table) {
          this.clearMethod()
          this.copyData = []
          this.userSelectContent = []//用户勾选的内容
          this.selectedRowKeys = []
        }
      }
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    pageSize: {
      type: Number,
      default: 5
    },
    pageSizeOptions: {
      type: Array,
      default () {
        return ['5', '10']
      }
    }
  },
  data () {
    return {
      taskPagination: {
        showTotal: total => `共 ${total} 条`,
        size: 'small',
        pageSizeOptions: this.pageSizeOptions
      },
      userSelectContent: [],//用户勾选的内容
      selectedRowKeys: [],
      reason: '',
      columns: [
        {
          title: '专家名称',
          scopedSlots: { customRender: 'expertName' }
        },
        {
          title: '单位名称',
          dataIndex: 'unitName'
        },
        {
          title: '品目名称',
          dataIndex: 'purchaseItem'
        },
        {
          title: '手机号',
          dataIndex: 'mobilePhone'
        },

      ],
      queryParam: {
        state: ExpertState.STATE.IN_SUCCESS,
      },
      copyData: [],
      confirmLoading: false,
      loadData: async parameter => {
        const params = { ...parameter, ...this.queryParam}
        return QueryExpertInfo(params)
      }
    }
  },
  created () {
  },
  methods: {
    //数据回显
    preView (json) {
      let that = this
      this.$nextTick(() => {
        that.selectedRowKeys = []
        json.forEach(item => {
          that.selectedRowKeys.push(item.id)
        })
        that.userSelectContent = json
        this.copyData =that.copyData.concat(json)
      })
    },
    //确认后数据传回调用方
    async handleOk () {
      this.$emit('success', this.userSelectContent)
    },
    //关闭窗口
    handleCancel () {
      this.$emit('cancel')
    },
    //清空的方法
    clearMethod () {
      this.queryParam = {
        state: ExpertState.STATE.IN_SUCCESS,
      }
      this.onSearch()
    },
    //选择专家
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.userSelectContent = []
      this.copyData = this.copyData.concat(selectedRows)
      console.log(this.copyData)
      selectedRowKeys.forEach(item => {
        const data = this.copyData.filter(it => it.id === item)[0]
        this.userSelectContent.push(data)
      })
    },
    //查询
    onSearch () {
      this.$refs.table.refresh(true)
    },
    //重置
    removeMethod (data) {
      this.userSelectContent = this.userSelectContent.filter(item => item.id !== data.id)
      this.selectedRowKeys = this.selectedRowKeys.filter(item => item !== data.id)
    },
  }
}
</script>

<style lang="less" scoped>
.card {
  margin-bottom: 24px;
}

.close-span:hover {
  cursor: pointer;
}
</style>
